import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate', standalone: true })
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit = 25, trail = '...'): string {
    return value?.length > limit ? value.slice(0, limit) + trail : value;
  }
}
